/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type App_QueryVariables = {};
export type App_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly user: ({
            readonly id: string;
        }) | null;
    }) | null;
};
export type App_Query = {
    readonly response: App_QueryResponse;
    readonly variables: App_QueryVariables;
};



/*
query App_Query {
  viewer {
    id
    user {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "viewer",
            "storageKey": null,
            "args": null,
            "concreteType": "Viewer",
            "plural": false,
            "selections": [
                (v0 /*: any*/),
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/)
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "App_Query",
            "argumentDefinitions": [],
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "App_Query",
            "id": null,
            "text": "query App_Query {\n  viewer {\n    id\n    user {\n      id\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'f83ec8e7106403c3a37649b3df50961c';
export default node;
